import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { initTheme } from './theme'
import { registerWorker } from './api/push'
import './index.css'

// Before React mounts, so the page never paints in the wrong theme and flips.
initTheme()

/*
 * <b>Registered on load, not on sign-in</b> (D-645).
 *
 * It used to happen inside the notification bell, which only mounts for a
 * signed-in account - so the sign-in screen, the first page any teacher sees,
 * had no service worker at all. Chrome decides whether a site is installable
 * from what it finds while somebody is using it, and there was nothing to find
 * until after they had signed in.
 *
 * Safe here, and `registerWorker`'s own comment already said so: registering
 * subscribes nobody and asks for no permission. It only makes the worker
 * present, which is the prerequisite for both push and installability.
 */
void registerWorker()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
